import { useEffect, useRef } from "react";

/** Every Next/Back in a multi-step form lands with the attached element (the progress bar) at the top of the screen. */
export function useStepTop(step) {
  const ref = useRef(null);
  const seen = useRef(step);
  useEffect(() => {
    if (seen.current === step) return;
    seen.current = step;
    const calm = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    requestAnimationFrame(() => ref.current?.scrollIntoView({ behavior: calm ? "auto" : "smooth", block: "start" }));
  }, [step]);
  return ref;
}
